import { FC } from "react";

import Box from "../Box/Box";
import styled from "styled-components";
import {
  BackgroundColorProps,
  BorderColorProps,
  ColorProps,
} from "styled-system";
import css from "@styled-system/css";

import DashedLine from "./DashedLine";
import StepLabel from "./StepLabel";
import Icon from "../Icon/Icon";
import { ItemProps } from "./HorizontalTimeline";

interface TimelineBlockProps {
  index: number;
  minContainerWidth: number;
  item: ItemProps;
  numberOfItems: number;
  labelsColor: ColorProps["color"];
  labelsBackgroundColor: BackgroundColorProps["backgroundColor"];
  labelsBorderColor: BorderColorProps["borderColor"];
  connectorColor: BorderColorProps["borderColor"];
}

const Container = styled(Box)<{ minContainerWidth: number }>`
  ${(props) =>
    css({
      [`@media only screen and (min-width: ${props.minContainerWidth}px)`]: {
        flexDirection: "row",
        width: "100%",
        mb: 6,
      },
    })}
`;

const TimelineBlock: FC<TimelineBlockProps> = ({
  index,
  minContainerWidth,
  item,
  numberOfItems,
  labelsColor,
  labelsBackgroundColor,
  labelsBorderColor,
  connectorColor,
}) => (
  <Container
    display="flex"
    flexDirection="column"
    alignItems="center"
    width="30px"
    mb={0}
    minContainerWidth={minContainerWidth}
  >
    {index !== 0 && (
      <DashedLine
        role="presentation"
        placement="start"
        minContainerWidth={minContainerWidth}
        width={0}
        display="none"
        connectorColor={connectorColor}
      />
    )}
    <StepLabel
      index={index}
      minContainerWidth={minContainerWidth}
      numberOfItems={numberOfItems}
      labelsColor={labelsColor}
      labelsBackgroundColor={labelsBackgroundColor}
      labelsBorderColor={labelsBorderColor}
    >
      {item.label === "number" ? (
        item.number
      ) : (
        <Icon
          width="14px"
          height="14px"
          name={item.iconName || "star"}
          weight={item.iconWeight || "regular"}
          color={labelsColor as string}
        />
      )}
    </StepLabel>
    {index !== numberOfItems && (
      <DashedLine
        role="presentation"
        placement="end"
        minContainerWidth={minContainerWidth}
        width={0}
        height="calc(100% - 48px)"
        connectorColor={connectorColor}
      />
    )}
  </Container>
);

export default TimelineBlock;
